module.exports = __webpack_public_path__ + "img/pvc_690g_candy_weiss.78fbddda.jpg";